import { getSheetUrl } from './sheetDomains';

const PARROTSHEETS_OG_IMAGE_URL = 'https://firebasestorage.googleapis.com/v0/b/parrotai-433712.firebasestorage.app/o/sheets%2FOLFECQu3m4Cc3id2yUlP%2F0qLetzuWuNfa0BHNI6OGw1xOBsw1%2Fmeta%2Fog%2F1775759283777_Parrotsheets_ogImage.png?alt=media&token=91f8cd14-82ba-4d5d-aad4-1f792422c94c';
const DEFAULT_SHEETS_THEME_COLOR = '#0b6b6b';
const normalizeThemeColor = (value) => {
  const normalized = `${value || ''}`.trim();
  if (!/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.test(normalized)) return '';
  return normalized.startsWith('#') ? normalized : `#${normalized}`;
};

export const buildSheetShareMetadata = (sheet = {}, options = {}) => {
  const sheetId = `${sheet?.id || options?.sheetId || ''}`.trim();
  const workspaceSlug = `${options?.workspaceSlug || sheet?.workspaceSlug || ''}`.trim();
  const customDomain = `${options?.customDomain || sheet?.customDomain || ''}`.trim();
  const title = `${sheet?.title || 'Untitled Sheet'}`.trim() || 'Untitled Sheet';
  const workspaceTitle = `${options?.workspaceTitle || sheet?.workspaceTitle || ''}`.trim();
  const description = `${sheet?.description || ''}`.trim()
    || (workspaceTitle
      ? `${title} in ${workspaceTitle} on ParrotSheets.`
      : 'Shared sheet from ParrotSheets.');
  const url = `${options?.pageUrl || getSheetUrl(sheetId, customDomain ? { customDomain } : workspaceSlug)}`.trim();
  const metaTitle = workspaceTitle
    ? `${title} | ${workspaceTitle} | ParrotSheets`
    : `${title} | ParrotSheets`;

  return {
    title,
    description,
    url,
    imageUrl: `${sheet?.ogImageUrl || PARROTSHEETS_OG_IMAGE_URL}`.trim(),
    themeColor: normalizeThemeColor(sheet?.primaryColor) || DEFAULT_SHEETS_THEME_COLOR,
    metaTitle,
    metaDescription: description
  };
};

export const applySheetPageMetadata = (metadata = {}) => {
  if (typeof document === 'undefined') return;

  const upsertMeta = (selector, attr, value, content) => {
    let meta = document.head.querySelector(selector);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attr, value);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };

  const title = `${metadata?.metaTitle || metadata?.title || 'ParrotSheets'}`.trim();
  const description = `${metadata?.metaDescription || metadata?.description || 'Shared sheet from ParrotSheets.'}`.trim();
  const url = `${metadata?.url || window.location.href}`.trim();
  const imageUrl = `${metadata?.imageUrl || PARROTSHEETS_OG_IMAGE_URL}`.trim();
  const themeColor = normalizeThemeColor(metadata?.themeColor) || DEFAULT_SHEETS_THEME_COLOR;

  document.title = title;
  upsertMeta('meta[name="description"]', 'name', 'description', description);
  upsertMeta('meta[name="theme-color"]', 'name', 'theme-color', themeColor);
  upsertMeta('meta[property="og:title"]', 'property', 'og:title', title);
  upsertMeta('meta[property="og:description"]', 'property', 'og:description', description);
  upsertMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
  upsertMeta('meta[property="og:url"]', 'property', 'og:url', url);
  upsertMeta('meta[property="og:image"]', 'property', 'og:image', imageUrl);
  upsertMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
  upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  upsertMeta('meta[name="twitter:image"]', 'name', 'twitter:image', imageUrl);
};
